import { NewVehicle } from './NewVehicle';

export const TestVehicle: NewVehicle = {
    vin: '1234',
    vinValid: true,
    makeCode: 'HY',
    make: 'Hyundai',
    year: '2008',
    model: 'Sonata',
    trim: 'CE',
    color: 'Red',
    estMileage: '25456',
    makeId: '',
    modelId: '',
};

export const EmptyVehicle: NewVehicle = {
    vin: '',
    vinValid: false,
    makeCode: '',
    make: '',
    year: '',
    model: '',
    trim: '',
    color: 'default',
    estMileage: '',
    makeId: '',
    modelId: '',
};